import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const RequireAuth = ({ allowedRoles }) => {
  const location = useLocation();
  const { roles } = useAuth();
  console.log(allowedRoles);
  console.log(roles);
  const notLoggedIn = roles.length === 0
  console.log(notLoggedIn);

  const hasAccess = roles?.some((role) => allowedRoles.includes(role));
  // console.log(hasAccess);
  
  return hasAccess ? (
    <Outlet />
  ) : notLoggedIn ? (
    <Navigate to="login" state={{ from: location }} replace />
  ) : (<Navigate to="/home/dash" ></Navigate>);
};

export default RequireAuth;
